var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRectangleLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 48,
    viewBox: "0 0 9 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000295276 4.00829C-0.00498627 1.79916 1.78207 0.00449798 3.9912 -0.000193007C6.20034 -0.004884 7.995 1.78217 7.99969 3.9913L8.08462 43.9912C8.08932 46.2003 6.30226 47.995 4.09313 47.9997C1.88399 48.0044 0.0893336 46.2173 0.0846426 44.0082L-0.000295276 4.00829Z",
    fill: "#002925"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRectangleLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/RectangleLine.82e382a1.svg";
export { ForwardRef as ReactComponent };